/*

Controller file for Leases

*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Reports = Class.create({
  	initialize: function() {
		this.limit = 'month';
    },
    getBasicStats: function(callback) {
        var url = "reports/stats";
		var data = server.getData(url,null,false);
		data
		.done(function(response){
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
				modal.showInfo("Error occurred: " + response.data.error + ". Please try again.", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    }
});

export let reports = new Reports();


// WEBPACK FOOTER //
// app/core/controllers/Reports.js